import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

interface TableColumn {
  key: string;
  label: string;
}

interface TableRow {
  [key: string]: string | number | boolean | null;
}

interface TableContent {
  caption: string | null;
  columns: TableColumn[];
  rows: TableRow[];
  compact: boolean;
}

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent {
  @Input() content!: TableContent;

  formatCellValue(value: string | number | boolean | null): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    // Truncate long strings in compact mode
    const str = String(value);
    if (this.content.compact && str.length > 100) {
      return str.substring(0, 100) + '...';
    }
    return str;
  }
}

